export default __webpack_public_path__ + "static/media/CYLEX_MANUAL.df74ce2d.png";